module.exports = __webpack_public_path__ + "img/4.28901442.png";